import React from 'react'
import { MenuItem, MenuList } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ spacing }) => ({
  listItem: {
    justifyContent: 'center'
  }
}))

const MobileMenu = ({
  value: currentValue,
  onChange,
  languages,
  className
}) => {
  const classes = useStyles()

  return (
    <MenuList
      variant='menu'
      autoFocusItem
      className={className}
      data-test='article-translate-menu'
    >
      {languages.map(({ label, value }, index) => (
        <MenuItem
          ListItemClasses={{ root: classes.listItem }}
          onClick={() => onChange(value)}
          selected={value === currentValue}
          key={value}
          data-test={`article-translate-item-${index}`}
        >
          {label}
        </MenuItem>
      ))}
    </MenuList>
  )
}

export default MobileMenu
